import { LBButton, LBMsTeamsIcon } from '@linearb/buzz';

const MsTeamsConnectButton = ({
  clientId = '',
  ButtonText: buttonText = ''
}) => (
  <LBButton asChild variant='outline'>
    <a href={clientId} target='_blank'>
      <LBMsTeamsIcon />
      {buttonText}
    </a>
  </LBButton>
);

export default MsTeamsConnectButton;
